export const blogPosts = [
  {
    slug: 'dangers-intoxication-alimentaire-evenements',
    title: "Intoxication alimentaire lors d'un événement : les risques souvent sous-estimés",
    excerpt: "Un buffet mal conservé, une paëlla servie trop longtemps à température ambiante… Les intoxications alimentaires lors d'événements privés sont plus fréquentes qu'on ne le croit. Comment les prévenir ?",
    category: 'Sécurité alimentaire',
    date: '18 mars 2026',
    readTime: '6 min',
    image: '/images/buffet2.jpg',
    content: [
      { type: 'h2', text: "Qu'est-ce qu'une intoxication alimentaire ?" },
      { type: 'p', text: "Une intoxication alimentaire (ou toxi-infection alimentaire) survient lorsque des aliments contaminés par des bactéries, virus ou toxines sont consommés. Les symptômes — nausées, vomissements, diarrhées, fièvre — apparaissent généralement entre 2 et 72 heures après l'ingestion." },
      { type: 'h2', text: "Pourquoi les événements sont-ils particulièrement à risque ?" },
      { type: 'p', text: "Lors d'un repas entre amis ou en entreprise, plusieurs facteurs aggravent les risques :" },
      { type: 'ul', items: [
        "Grandes quantités préparées à l'avance : plus la nourriture attend, plus les bactéries ont le temps de se multiplier",
        "Rupture de la chaîne du froid : les plats laissés à température ambiante pendant les cocktails ou les buffets",
        "Matériel de service non adapté : manque de maintien au chaud ou au froid",
        "Manipulation par de nombreuses personnes : risque de contamination croisée"
      ]},
      { type: 'h2', text: "Les bactéries les plus fréquentes" },
      { type: 'p', text: "Salmonella : présente dans la volaille, les œufs et les produits laitiers non pasteurisés. Cause une gastro-entérite sévère." },
      { type: 'p', text: "Staphylococcus aureus : se développe très rapidement dans les plats riches (mayonnaise, crèmes). Résiste à la cuisson une fois les toxines produites." },
      { type: 'p', text: "Listeria monocytogenes : particulièrement dangereuse pour les femmes enceintes et les personnes âgées. Présente dans les charcuteries et fromages à pâte molle." },
      { type: 'h2', text: "Les bonnes pratiques pour vos événements" },
      { type: 'h3', text: "Côté froid" },
      { type: 'ul', items: [
        "Maintenir les plats froids à moins de 4°C jusqu'au service",
        "Ne jamais laisser un buffet froid plus de 2 heures à température ambiante",
        "Utiliser des bacs réfrigérés ou de la glace pour les buffets extérieurs en été"
      ]},
      { type: 'h3', text: "Côté chaud" },
      { type: 'ul', items: [
        "Maintenir les plats chauds à plus de 63°C en permanence",
        "Éviter de réchauffer plusieurs fois le même plat"
      ]},
      { type: 'h3', text: "Hygiène générale" },
      { type: 'ul', items: [
        "Lavage des mains systématique avant manipulation",
        "Ustensiles distincts pour chaque plat (éviter la contamination croisée)",
        "Ne pas mélanger produits crus et cuits"
      ]},
      { type: 'h2', text: "Pourquoi faire appel à un traiteur professionnel ?" },
      { type: 'p', text: "Un traiteur formé aux règles d'hygiène HACCP respecte des protocoles stricts à chaque étape : sélection des produits, préparation, transport et service. La cuisson en direct devant les invités (comme la paëlla ou le méchoui) est l'une des garanties les plus fortes : les aliments passent directement du feu à l'assiette, sans rupture de la chaîne." }
    ]
  },
  {
    slug: 'allergies-alimentaires-evenements-ce-quil-faut-savoir',
    title: "Allergies alimentaires lors de vos réceptions : tout ce qu'il faut savoir",
    excerpt: "Gluten, fruits à coque, lactose, crustacés… En France, 14 allergènes majeurs doivent être déclarés. Comment organiser un repas qui accueille tout le monde sans risque ?",
    category: 'Santé & Allergies',
    date: '10 mars 2026',
    readTime: '7 min',
    image: '/images/paella.jpg',
    content: [
      { type: 'h2', text: "Les allergies alimentaires, une réalité croissante" },
      { type: 'p', text: "En France, environ 3,5 millions de personnes souffrent d'une allergie alimentaire. Chez les enfants, ce chiffre est encore plus élevé. Contrairement à une simple intolérance, une allergie peut provoquer une réaction anaphylactique — potentiellement mortelle en quelques minutes." },
      { type: 'h2', text: "Les 14 allergènes majeurs à connaître" },
      { type: 'p', text: "Le règlement européen INCO impose de déclarer 14 allergènes majeurs dans tout service de restauration :" },
      { type: 'ol', items: [
        "Gluten (blé, seigle, orge, avoine…)",
        "Crustacés (crevettes, homard, crabes…)",
        "Œufs",
        "Poissons",
        "Cacahuètes (arachides)",
        "Soja",
        "Lait (lactose inclus)",
        "Fruits à coque (noix, amandes, noisettes, noix de cajou…)",
        "Céleri",
        "Moutarde",
        "Graines de sésame",
        "Dioxyde de soufre et sulfites (vins, charcuteries…)",
        "Lupin",
        "Mollusques (moules, palourdes, escargots…)"
      ]},
      { type: 'h2', text: "Les erreurs courantes lors des événements" },
      { type: 'h3', text: "Sous-estimer les traces" },
      { type: 'p', text: "Un plat peut ne pas contenir de cacahuètes mais avoir été préparé dans un atelier qui en utilise. Ces traces suffisent à déclencher une réaction chez les personnes les plus sensibles." },
      { type: 'h3', text: "Penser que cuire neutralise l'allergène" },
      { type: 'p', text: "Faux. Les protéines allergènes résistent généralement très bien à la chaleur. Cuire une crevette ne la rend pas inoffensive pour quelqu'un d'allergique aux crustacés." },
      { type: 'h2', text: "Organiser un repas inclusif" },
      { type: 'p', text: "Avant l'événement : collectez les informations allergiques de tous les invités à l'avance, prévoyez des alternatives clairement identifiées (étiquettes colorées), et communiquez au traiteur la liste complète des allergies." },
      { type: 'p', text: "Le jour J : désignez un référent allergies parmi les convives ou le personnel, servez en priorité les convives allergiques avec des ustensiles propres, et ne changez jamais la composition d'un plat sans en informer les personnes concernées." },
      { type: 'h2', text: "Que faire en cas de réaction allergique ?" },
      { type: 'ol', items: [
        "Appelez immédiatement le 15 (SAMU) ou le 112",
        "Si la personne dispose d'une auto-injection d'adrénaline (EpiPen), aidez-la à l'utiliser",
        "Allongez la personne (jambes surélevées sauf si difficultés respiratoires)",
        "Ne laissez jamais la personne seule"
      ]},
      { type: 'h2', text: "Le rôle du traiteur professionnel" },
      { type: 'p', text: "Un traiteur sérieux doit être capable de vous communiquer la liste complète des ingrédients et des allergènes présents dans chaque préparation. C'est une obligation légale, mais aussi une question de responsabilité humaine. N'hésitez pas à poser la question lors de votre prise de contact." }
    ]
  },
  {
    slug: 'reussir-sa-paella-en-exterieur-conseils-pro',
    title: "Les secrets d'une paëlla réussie en plein air : conseils de professionnel",
    excerpt: "Riz qui colle, bouillon mal dosé, feu inégal… La paëlla géante, c'est tout un art. Découvrez les astuces qui font la différence entre un plat quelconque et une paëlla inoubliable.",
    category: 'Cuisine & Savoir-faire',
    date: '2 mars 2026',
    readTime: '8 min',
    image: '/images/paella3.jpg',
    content: [
      { type: 'h2', text: "La paëlla, bien plus qu'un plat" },
      { type: 'p', text: "Originaire de Valence, la paëlla est à la fois une technique culinaire, un rituel social et un art du feu. En la cuisinant devant vos invités, un traiteur ne fait pas que préparer un repas — il crée une ambiance, un spectacle, une expérience collective." },
      { type: 'h2', text: "Le choix du riz : la base de tout" },
      { type: 'p', text: "Le riz rond espagnol (Bomba ou Calasparra) est indispensable. Il absorbe deux à trois fois son volume de bouillon sans devenir collant, et résiste mieux à la chaleur intense d'une paëlla géante." },
      { type: 'p', text: "À éviter absolument : le riz long grain (type Basmati), le riz à risotto et les riz précuits." },
      { type: 'h2', text: "Le bouillon : l'âme du plat" },
      { type: 'p', text: "Un bon bouillon fait toute la différence. Pour une paëlla aux fruits de mer, un fumet de poisson maison (têtes de crevettes, arêtes, légumes aromatiques) est incomparable. La règle du ratio : comptez environ 3 volumes de bouillon pour 1 volume de riz — et on n'y touche plus une fois versé." },
      { type: 'h2', text: "La maîtrise du feu : le secret des grands" },
      { type: 'p', text: "La paëlla doit cuire à feu vif au début pour créer le fameux socarrat — la légère croûte caramélisée au fond du plat — puis à feu doux pour finir la cuisson. Un feu inégal donnera un riz cuit par endroits et cru à d'autres." },
      { type: 'h2', text: "Les erreurs classiques à éviter" },
      { type: 'ul', items: [
        "Remuer le riz : c'est la plus grande erreur. On ne touche plus le riz une fois le bouillon ajouté",
        "Couvrir la paëlla : non, la paëlla cuit à découvert pour permettre l'évaporation",
        "Ajouter de l'eau en cours de cuisson : si le bouillon s'évapore trop vite, baissez la flamme",
        "Servir trop tôt : laissez reposer 5 minutes hors du feu avant de servir"
      ]},
      { type: 'h2', text: "La touche finale : le citron" },
      { type: 'p', text: "Un filet de citron pressé au moment du service réveille tous les arômes et équilibre le gras des fruits de mer. Simple mais transformateur." },
      { type: 'h2', text: "Pourquoi la paëlla en direct fascine toujours" },
      { type: 'p', text: "Il y a quelque chose de presque magique dans la cuisson d'une paëlla géante en plein air. L'odeur du safran, le crépitement du feu, la vapeur qui monte… C'est une expérience qui rassemble les gens, crée des conversations et des souvenirs." }
    ]
  },
  {
    slug: 'organiser-buffet-evenement-guide-complet',
    title: "Comment organiser un buffet parfait pour votre événement : le guide complet",
    excerpt: "Anniversaire, mariage, séminaire d'entreprise… Quelle quantité prévoir ? Comment agencer les plats ? À quelle température servir ? Toutes les réponses pour un buffet réussi.",
    category: 'Organisation & Conseils',
    date: '22 février 2026',
    readTime: '7 min',
    image: '/images/buffet3.jpg',
    content: [
      { type: 'h2', text: "Bien dimensionner son buffet" },
      { type: 'h3', text: "Pour un cocktail dinatoire (plats en mignardises)" },
      { type: 'ul', items: ["8 à 12 pièces par personne", "4 à 6 types de préparations différentes"] },
      { type: 'h3', text: "Pour un buffet dînatoire complet" },
      { type: 'ul', items: ["250 à 350 g de plats chauds par personne", "150 à 200 g de salades et entrées", "100 à 150 g de desserts"] },
      { type: 'p', text: "Conseil pro : Prévoyez toujours 10% de plus que le nombre d'invités confirmés. Les convives mangent presque toujours plus qu'on ne le prévoit, surtout lors d'un événement festif." },
      { type: 'h2', text: "L'agencement : une science à part entière" },
      { type: 'p', text: "L'ordre dans lequel les plats sont présentés influence directement la façon dont vos invités se servent." },
      { type: 'ol', items: [
        "Commencer par les assiettes et couverts (souvent oubliés en dernier !)",
        "Les entrées froides et salades",
        "Les plats chauds",
        "Les garnitures et accompagnements",
        "Le pain en fin de ligne",
        "Les desserts sur une table séparée si possible"
      ]},
      { type: 'h2', text: "La gestion des températures" },
      { type: 'p', text: "Plats froids : maintenus à moins de 4°C grâce à des bacs sur glace. Ne les sortez pas plus de 30 minutes avant le service." },
      { type: 'p', text: "Plats chauds : maintenus à plus de 63°C via des chafing dishes (bains-marie). La règle des 2 heures : au-delà de 2 heures à température ambiante, un plat ne doit plus être consommé." },
      { type: 'h2', text: "La présentation : l'œil mange aussi" },
      { type: 'ul', items: [
        "Jouez sur les hauteurs : des plats surélevés donnent du relief et de la dynamique",
        "Les couleurs : panacher les couleurs des plats pour un visuel appétissant",
        "Le garnissage : herbes fraîches, tranches de citron, tomates cerise",
        "Le renouvellement : rechargez les plats avant qu'ils soient vides, pas après"
      ]},
      { type: 'h2', text: "Combien de temps à l'avance préparer ?" },
      { type: 'ul', items: [
        "J-7 : finaliser le menu et les quantités avec le traiteur",
        "J-1 : préparer les plats froids, les sauces, les desserts",
        "Jour J matin : mise en place des tables et du matériel de service",
        "2h avant : démarrage de la cuisson des plats chauds",
        "30 min avant : installation complète du buffet"
      ]}
    ]
  },
  {
    slug: 'mechoui-tradition-et-savoir-faire',
    title: "Le méchoui : une tradition millénaire au cœur de vos fêtes",
    excerpt: "Agneau entier rôti à la broche, cuisson lente au feu de bois, chair fondante et dorée… Le méchoui est bien plus qu'un plat, c'est une cérémonie. Origines, traditions et secrets de la cuisson parfaite.",
    category: 'Culture & Gastronomie',
    date: '14 février 2026',
    readTime: '6 min',
    image: '/images/bob2.jpg',
    content: [
      { type: 'h2', text: "Les origines du méchoui" },
      { type: 'p', text: "Le mot méchoui vient de l'arabe mechwi (مشوي), qui signifie simplement grillé. Cette tradition culinaire berbère et maghrébine remonte à plusieurs siècles, pratiquée lors des grandes célébrations : mariages, naissances, fêtes religieuses." },
      { type: 'h2', text: "L'agneau : le choix déterminant" },
      { type: 'p', text: "La qualité du méchoui commence par le choix de l'animal. Un agneau de lait (moins de 30 kg) donnera une chair plus fine et plus tendre. Un agneau plus lourd (jusqu'à 50 kg) offrira des portions plus généreuses." },
      { type: 'ul', items: [
        "Viande rosée, jamais rouge foncé",
        "Gras blanc nacré (signe de fraîcheur)",
        "Provenance locale de préférence (traçabilité et fraîcheur garanties)"
      ]},
      { type: 'h2', text: "Les épices : l'âme du méchoui" },
      { type: 'p', text: "La marinade traditionnelle repose sur cumin, coriandre moulue, paprika doux, ail en quantité généreuse mélangé à du beurre clarifié ou de l'huile d'olive, et du sel en grande quantité. La marinade est frottée sur toute la surface et laissée au repos minimum 12 heures, idéalement 24 heures." },
      { type: 'h2', text: "La cuisson : une patience récompensée" },
      { type: 'p', text: "La règle d'or : cuisson lente, feu modéré. Un agneau de 25-30 kg demande environ 4 à 5 heures. La broche doit tourner en continu, le feu de bois maintenu à distance régulière. Il faut arroser régulièrement avec le jus de cuisson." },
      { type: 'h2', text: "Le service traditionnel" },
      { type: 'p', text: "Dans la tradition, le méchoui se mange avec les mains — c'est sa magie. Les convives se servent directement, effilochant la viande tendre, partageant la même pièce, dans une atmosphère de convivialité authentique." },
      { type: 'ul', items: [
        "Semoule de couscous nature ou aux légumes",
        "Salades marocaines (carottes épicées, betteraves, poivrons grillés)",
        "Pain traditionnel (khobz)",
        "Coriandre fraîche et piments doux"
      ]},
      { type: 'h2', text: "Pourquoi le méchoui crée-t-il de la fête ?" },
      { type: 'p', text: "Il y a quelque chose d'archaïque et de profondément humain dans la cuisson d'un animal entier au feu de bois. L'odeur qui se répand, la fumée qui monte, la chaleur du feu, les convives qui se rassemblent autour… C'est un retour aux sources que vos invités n'oublieront pas." }
    ]
  }
];

export const getBlogPost = (slug) => blogPosts.find(p => p.slug === slug);
